module.exports = __webpack_public_path__ + "img/softball1.3137e36f.jpg";